import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage/plugin-tech-radar';

import { techRadarData } from './TechRadarData';

export class TechRadarClient implements TechRadarApi {
  async load(): Promise<TechRadarLoaderResponse> {
    return new Promise<TechRadarLoaderResponse>((resolve, _reject) => {
      resolve(techRadarData);
    });
  }
}
